import { Button, IconButton, TableCell, TableRow } from '@/common'
import { TrashIcon } from '@/common/components/icons'
import { Installation } from '@/features/suppliers/hooks/installations'
import { Link } from 'react-router-dom'
import useI18n from '@/shared/hooks/usei18n'
import { useGetAllSupplierEmissionsReportsForInstallation } from '@/features/suppliers/hooks/supplierEmissionsReport'
import { ImportedGood } from '@/features/cbam-reporting/hooks/importedGoods'

export default function InstallationRow({
  installation,
  importedGoods,
  onDeleteClick
}: {
  installation: Installation
  importedGoods: ImportedGood[]
  onDeleteClick: () => void
}) {
  const { t } = useI18n()
  const { data: emissionsReports } = useGetAllSupplierEmissionsReportsForInstallation(
    installation.partnershipId,
    installation.id
  )
  const numberOfEmissionsReports = emissionsReports?.length || 0
  const quantityReported = importedGoods.reduce(
    (acc, importedGood) => acc + importedGood.netMassInTonnes,
    0
  )

  return (
    <TableRow key={installation.id}>
      <TableCell>{installation.name}</TableCell>
      <TableCell>
        {installation.city}
        <div>
          <span className="text-sm">
            {t(`common:countriesByIsoAlpha2.${installation.country}`)}
          </span>
        </div>
        <div />
      </TableCell>
      <TableCell>{t(`common:goodsFamily.${installation.goodsFamily}`)}</TableCell>
      <TableCell align="right">{numberOfEmissionsReports}</TableCell>
      <TableCell align="right">{quantityReported ? `${quantityReported} t` : '-'}</TableCell>
      <TableCell align="right">
        <div className="flex items-center gap-2 justify-end">
          <Link to={`/suppliers/${installation.partnershipId}/installations/${installation.id}`}>
            <Button variant="txt-default" sizeType="sm">
              {t('common:actions.view')}
            </Button>
          </Link>
          <IconButton
            icon={<TrashIcon />}
            variant="txt-danger"
            sizeType="sm"
            onClick={onDeleteClick}
          />
        </div>
      </TableCell>
    </TableRow>
  )
}
